var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareRec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 2.0835C12.9978 2.0835 15.8334 4.91903 15.8334 8.41683C15.8334 10.4341 14.8903 12.231 13.4209 13.3909L13.4596 13.3601L13.4589 18.111C13.4589 18.5459 13.0069 18.8332 12.6132 18.6487L9.50044 17.19L6.38932 18.6486C5.99558 18.8332 5.54352 18.5459 5.54352 18.111L5.54224 13.3615C4.09493 12.2026 3.16669 10.4181 3.16669 8.41683C3.16669 4.91903 6.00222 2.0835 9.50002 2.0835ZM12.2718 14.113L12.3037 14.0974C11.4585 14.5153 10.5067 14.7502 9.50002 14.7502C8.60907 14.7502 7.76109 14.5662 6.99199 14.2342L6.73061 14.1142L6.73102 17.1769L9.24832 15.9967C9.40798 15.9218 9.59265 15.9218 9.75233 15.9966L12.2714 17.1771L12.2718 14.113ZM9.50002 3.271C6.65805 3.271 4.35419 5.57486 4.35419 8.41683C4.35419 11.2588 6.65805 13.5627 9.50002 13.5627C12.342 13.5627 14.6459 11.2588 14.6459 8.41683C14.6459 5.57486 12.342 3.271 9.50002 3.271ZM9.68114 5.75869L10.4036 7.22537L12.0217 7.4592C12.1874 7.48314 12.2536 7.68678 12.1337 7.80363L10.9634 8.944L11.2396 10.5554C11.2679 10.7204 11.0947 10.8461 10.9466 10.7681L9.50002 10.0062L8.05348 10.7681C7.90529 10.8462 7.73198 10.7202 7.76042 10.5552L8.03807 8.944L6.86641 7.80371C6.74638 7.68689 6.81258 7.48315 6.97835 7.4592L8.59648 7.22537L9.3189 5.75869C9.3929 5.60843 9.60714 5.60843 9.68114 5.75869Z",
    fill: "url(#paint0_linear_10624_8851)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10624_8851",
    x1: 9.50002,
    y1: 2.0835,
    x2: 9.50002,
    y2: 18.7055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0977D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053F71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareRec);
export default __webpack_public_path__ + "static/media/compare-rec.4da9fdf4d57ce09e56980f35dd1c8073.svg";
export { ForwardRef as ReactComponent };